import { DatiqLogLevels } from '../models';
import { IDatiqLogEntity } from './datiq-log.models';

export const makeInfoEntity: (
    message: string,
    info?: unknown
) => IDatiqLogEntity = (message: string, info?: unknown): IDatiqLogEntity =>
    makeLogEntity(DatiqLogLevels.Info, message, info);
export const makeErrorEntity: (
    message: string,
    info?: unknown
) => IDatiqLogEntity = (message: string, info?: unknown): IDatiqLogEntity =>
    makeLogEntity(DatiqLogLevels.Error, message, info);
export const makeDebugEntity: (
    message: string,
    info?: unknown
) => IDatiqLogEntity = (message: string, info?: unknown): IDatiqLogEntity =>
    makeLogEntity(DatiqLogLevels.Debug, message, info);
export const makeWarningEntity: (
    message: string,
    info?: unknown
) => IDatiqLogEntity = (message: string, info?: unknown): IDatiqLogEntity =>
    makeLogEntity(DatiqLogLevels.Warning, message, info);
export const makeJsErrorEntity: (
    message: string,
    error: Error,
    info: unknown
) => IDatiqLogEntity = (
    message: string,
    error: Error,
    info?: unknown
): IDatiqLogEntity => ({
    ...makeLogEntity(DatiqLogLevels.JsError, message, info),
    error: { stack: error.stack },
});
export const makeLogEntity: (
    level: DatiqLogLevels,
    message: string,
    info?: unknown
) => IDatiqLogEntity = (
    level: DatiqLogLevels,
    message: string,
    info?: unknown
): IDatiqLogEntity => {
    const timeInMs: number = Date.now();
    const id = `${timeInMs}`;
    const timestamp: Date = new Date(timeInMs);

    return !!info
        ? {
              id,
              log: {
                  id,
                  message,
                  info,
                  level,
                  timestamp,
              },
          }
        : {
              id,
              log: {
                  id,
                  message,
                  level,
                  timestamp,
              },
          };
};
